import { LOGIN_TIMEOUT_MS } from "@/utils/loginRequest";
import axios from "axios"
import { createAsyncThunk } from "@reduxjs/toolkit"
import Cookies from 'js-cookie';

const url = process.env.NEXT_PUBLIC_BASE_URL;

export const userData = createAsyncThunk("/userData", async (data, { rejectWithValue, signal }) => {

    let {token} = data;
    if (!data?.token) {
       token = Cookies.get('token')
    }
    try {
        const response = await axios.get(`${url}/users/user-data`, { params: {...data, token}, timeout: LOGIN_TIMEOUT_MS, signal });
        return response.data;
    } catch (error) {
        if (error.response?.data?.code === "ACCOUNT_DISABLED") {
            return rejectWithValue(error.response.data, { sessionToken: token, sessionType: data?.type });
        }
        throw error;
    }
 })
 

